// import React, { useEffect, useState } from 'react';
// import { Box } from '@mui/material';
// import axios from 'axios';
// import { MessageInput } from './MessageInput';
// import ChatWindow from './ChatWindow';
// import { Sidebar } from './Sidebar';
// import { io } from 'socket.io-client';
// import { isEmpty, map } from 'lodash';
// import socket from './socket';

// export default function SCChat() {
//   const [clients, setClients] = useState([]);
//   const [selectedClients, setSelectedClients] = useState([]);
//   const [messages, setMessages] = useState([]);
//   const [unreadCounts, setUnreadCounts] = useState({});
//   // const [socket, setSocket] = useState();
//   const [loadingMessages, setLoadingMessages] = useState(false);

//   const user = {
//     id: parseInt(localStorage?.getItem('user_id')),
//     user_name: localStorage?.getItem('user_name'),
//     event_id: parseInt(localStorage?.getItem('event_id')),
//   };

//   // 1️⃣ Load clients
//   useEffect(() => {
//     axios
//       .get(`${process.env.REACT_APP_API_URL}/messages/listusers`)
//       .then((res) => {
//         setClients(res.data);
//         socket.on('unread_counts', (counts) => {
//           setUnreadCounts(counts);
//           console.log('Clearing ======', counts);
//         });
//       });
//   }, []);

//   const clearCounts = (sender_id, receiver_id) => {
//     socket.emit('read_messages', {
//       sender_id: sender_id,
//       receiver_id: receiver_id,
//       // message_ids: Object.keys(counts).filter((id) => counts[id] > 0),
//     });
//     console.log('Clearing counts:', sender_id, ' and ', receiver_id);
//   };
//   // useEffect(() => {
//   //   if (!user) return;

//   //   const s = io(SOCKET_URL, { query: { user_id: user.id } });
//   //   setSocket(s);

//   //   return () => s.disconnect();
//   // }, []);

//   console.log('messages', messages);

//   // 2️⃣ Load messages for selected CUs
//   useEffect(() => {
//     if (selectedClients.length === 0) {
//       setMessages([]);
//       return;
//     }
//     const ids = selectedClients.map((c) => c.id).join(',');
//     setLoadingMessages(true);
//     axios
//       .get(
//         `${process.env.REACT_APP_API_URL}/messages/messages/${user?.event_id}/sc/${user.id}/${ids}`
//       )
//       .then((res) =>
//         setMessages(
//           map(res.data, (msg) => {
//             return {
//               ...msg,
//               msg_sender:
//                 msg.sender_id === parseInt(user.id)
//                   ? 'C'
//                   : selectedClients[0]?.gps_unit_name,
//             };
//           })
//         )
//       )
//       .catch((err) => console.error('Failed to load messages:', err))
//       .finally(() => setLoadingMessages(false)); // ✅ stop loading
//   }, [selectedClients, user.id]);

//   // 3️⃣ Socket events
//   useEffect(() => {
//     if (!socket) return;

//     socket.emit('join', { user_id: user.id });

//     socket.on('new_message', (msg) => {
//       setMessages((prev) =>
//         map([...prev, msg], (msg) => {
//           return {
//             ...msg,
//             msg_sender:
//               msg.sender_id === parseInt(user.id)
//                 ? 'C'
//                 : selectedClients[0]?.gps_unit_name,
//           };
//         })
//       );
//     });

//     // if (selectedClients[0]?.id) {
//     //   socket.emit('read_messages', { user_id: selectedClients[0]?.id });
//     // }

//     // socket.on('message_read', (data) => {
//     //   console.log("data in sc=====",data);

//     //   setMessages((prev) =>
//     //     map([...prev, data], (msg) => {
//     //       return {
//     //         ...msg,
//     //         read: true,
//     //         read_at: data.read_at,
//     //         msg_sender:
//     //           msg.sender_id === parseInt(user.id)
//     //             ? user?.user_name
//     //             : selectedClients[0]?.username,
//     //       };
//     //     })
//     //   );
//     // });

//     // socket.on("message_read", (data) => {
//     //   setMessages((prev) =>
//     //     prev.map((m) =>
//     //       m.id === data.message_id
//     //         ? { ...m, read: true, read_at: data.read_at }
//     //         : m
//     //     )
//     //   );
//     // });

//     return () => {
//       socket.emit('leave', { user_id: user.id });
//     };
//   }, [socket, user?.id]);

//   useEffect(() => {
//     socket.on('unread_counts', (counts) => setUnreadCounts(counts));
//     return () => socket.off('unread_counts'); // clean up
//   }, [socket]);

//   useEffect(() => {
//     if (user?.id && selectedClients[0]?.id) {
//       clearCounts(selectedClients[0]?.id, user?.id);
//     }
//   }, [selectedClients, user?.id, messages]);

//   // 4️⃣ Send message
//   const sendMessage = async (data) => {
//     if (selectedClients.length === 0)
//       return alert('Select at least one client');

//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_API_URL}/messages/sendmessage/${user?.event_id}`,
//         {
//           sender_id: user.id,
//           content: data?.text,
//           emcode: data?.dropdown1,
//           emaction: data?.dropdown2,
//           emlocation: data?.dropdown3,
//           attachment_url: !isEmpty(data?.attachments)
//             ? JSON.stringify(data?.attachments)
//             : '',
//           receiver_ids: selectedClients.map((c) => c.id),
//         }
//       );

//       // res.data should be the newly created message object
//       // Adjust property names according to your API response
//       // const newMessage = res.data;

//       // setMessages((prev) => [...prev, newMessage]);
//     } catch (err) {
//       console.error('Error sending message:', err);
//     }
//   };

//   // const markMessagesRead = (clientIds) => {
//   //   if (!socket || clientIds.length === 0) return;
//   //   socket.emit('mark_read', {
//   //     user_id: user.id, // who is reading
//   //     client_ids: clientIds, // whose messages are being read
//   //   });
//   // };

//   // useEffect(() => {
//   //   if (selectedClients.length > 0) {
//   //     // when you open a chat, mark unread messages as read
//   //     markMessagesRead(selectedClients.map((c) => c.id));
//   //   }
//   // }, [selectedClients, messages]);

//   console.log('SSC------', messages);

//   return (
//     // <div className="flex h-screen">
//     //   <Sidebar
//     //     users={clients}
//     //     unreadCounts={unreadCounts}
//     //     selectedUsers={selectedClients}
//     //     onSelect={setSelectedClients}
//     //   />
//     //   <div className="flex flex-col flex-1">
//     //     <ChatWindow messages={messages} scId={user.id} />
//     //     <MessageInput onSend={sendMessage} />
//     //   </div>
//     // </div>

//     <Box sx={{ display: 'flex', height: '100vh', bgcolor: '#e5ddd5' }}>
//       {/* Sidebar */}
//       <Sidebar
//         users={clients}
//         unreadCounts={unreadCounts}
//         selectedUsers={selectedClients}
//         onSelect={setSelectedClients}
//       />

//       {/* Chat area */}
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: 'column',
//           flex: 1,
//           borderLeft: '1px solid #ddd',
//         }}
//       >
//         {/* Chat window (header + messages) */}
//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             flex: 1,
//             overflow: 'hidden',
//           }}
//         >
//           {console.log('selected', selectedClients)}
//           <ChatWindow
//             loadingMessages={loadingMessages}
//             messages={messages}
//             scId={user.id}
//             selectedClients={selectedClients}
//             selectedUser={
//               selectedClients?.length === 1
//                 ? selectedClients[0]?.username
//                 : 'BROADCAST ALL'
//             }
//           />
//         </Box>

//         {/* Message input */}
//         <Box>
//           <MessageInput
//             onSend={sendMessage}
//             disabled={isEmpty(selectedClients)}
//           />
//         </Box>
//       </Box>
//     </Box>
//   );
// }

import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import axios from 'axios';
import { MessageInput } from './MessageInput';
import ChatWindow from './ChatWindow';
import { Sidebar } from './Sidebar';
import { io } from 'socket.io-client';
import { isEmpty, last, map, sortBy } from 'lodash';
import socket, { joinRoom } from './socket';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

export default function SCChat() {
  const location = useLocation();
  const [clients, setClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [messages, setMessages] = useState([]);
  const [unreadCounts, setUnreadCounts] = useState({});
  // const [socket, setSocket] = useState();
  const [loadingMessages, setLoadingMessages] = useState(false);
  // const path = location?.pathname
  // const isReadOnly = location?.pathname === '/view-control-room-chat' ? true : false

  const user = {
    id: parseInt(localStorage?.getItem('user_id')),
    user_name: localStorage?.getItem('user_name'),
    event_id: parseInt(localStorage?.getItem('event_id')),
  };

  // useEffect(() => {
  //   if (selectedClients.length === 0) {
  //     setMessages([]);
  //     return;
  //   }
  //   const ids = selectedClients.map((c) => c.id).join(',');
  //   setLoadingMessages(true);
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_API_URL}/messages/messages/${user?.event_id}/sc/${user.id}/${ids}`
  //     )
  //     .then((res) =>
  //       setMessages(
  //         map(res.data, (msg) => {
  //           return {
  //             ...msg,
  //             msg_sender:
  //               msg.sender_id === parseInt(user.id)
  //                 ? 'C'
  //                 : selectedClients[0]?.gps_unit_name,
  //           };
  //         })
  //       )
  //     )
  //     .catch((err) => console.error('Failed to load messages:', err))
  //     .finally(() => setLoadingMessages(false)); // ✅ stop loading
  // }, [selectedClients]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/messages/listusers`)
      .then((res) => {
        setClients(
          sortBy(res?.data, [
            (item) => item.gps_unit_name.match(/[A-Za-z]+/)?.[0] || '',
            (item) => parseInt(item.gps_unit_name.match(/\d+/)?.[0] || 0, 10),
          ])
        );
        // setClients(sortBy(res?.data,'gps_unit_name'));
        socket.on('unread_counts', (counts) => {
          console.log('unread_counts1 ======', counts);

          setUnreadCounts(counts);
          console.log('Clearing ======', counts);
        });
      });
  }, []);

  // useEffect(() => {
  //   // Join room for this user
  //   joinRoom(user?.id);

  //   // New messages
  //   socket.on('new_message', (data) => {
  //     console.log('📩 new_message:', data);
  //     setMessages((prev) =>
  //       map([...prev, data], (msg) => {
  //         return {
  //           ...msg,
  //           msg_sender:
  //             msg.sender_id === parseInt(user.id)
  //               ? 'C'
  //               : selectedClients[0]?.gps_unit_name,
  //         };
  //       })
  //     );
  //   });

  //   // Unread counts
  //   socket.on('unread_counts', (data) => {
  //     console.log('🔢 unread_counts:', data);
  //     setUnreadCounts(data);
  //   });

  //   // Debug connect/disconnect
  //   socket.on('connect', () => console.log('✅ Connected:', socket.id));
  //   socket.on('disconnect', (reason) =>
  //     console.log('❌ Disconnected:', reason)
  //   );
  //   socket.on('connect_error', (err) =>
  //     console.error('Socket connect error:', err)
  //   );

  //   return () => {
  //     socket.off('new_message');
  //     socket.off('unread_counts');
  //     socket.off('connect');
  //     socket.off('disconnect');
  //   };
  // }, [user?.id,socket]);

  useEffect(() => {
    socket.connect();
    socket.emit('join', { user_id: user?.id });

    socket.on('new_message', (msg) => {
      console.log('Received new_message:', msg);
      if (
        (selectedClients && msg.sender_id === selectedClients[0]?.id) ||
        msg?.receivers?.includes(selectedClients[0]?.id)
      ) {
        setMessages((prev) =>
          map([...prev, msg], (msg) => {
            return {
              ...msg,
              msg_sender:
                msg.sender_id === parseInt(user.id)
                  ? 'C'
                  : selectedClients[0]?.gps_unit_name,
            };
          })
        );
      }
      setUnreadCounts((prev) => ({
        ...prev,
        [msg.sender_id]: (prev[msg.sender_id] || 0) + 1,
      }));
    });

    socket.on('message_read', (payload) => {
      setMessages((prev) =>
        prev.map((m) => {
          if (m.id === payload.message_id) {
            return {
              ...m,
              msg_sender:
                m.sender_id === parseInt(user.id)
                  ? 'C'
                  : selectedClients[0]?.gps_unit_name,
              reads: m?.reads?.map((r) =>
                r.receiver_id === payload.reader_id
                  ? { ...r, read: true, read_at: payload.read_at }
                  : r
              ),
            };
          }
          return m;
        })
      );
    });

    socket.on('unread_counts', (counts) => {
      setUnreadCounts(counts);
    });

    return () => socket.disconnect();
  }, [selectedClients, messages]);

  const fetchMessages = (eventId, role, userId, cuIds = null) => {
    setLoadingMessages(true);

    let url = `${process.env.REACT_APP_API_URL}/messages/messages/${eventId}/${role}/${userId}`;
    if (cuIds) url += `/${cuIds.join(',')}`;

    return axios
      .get(url)
      .then((res) =>
        map(res?.data, (msg) => ({
          ...msg,
          msg_sender:
            msg.sender_id === parseInt(user.id)
              ? 'C'
              : selectedClients[0]?.gps_unit_name,
        }))
      )
      .finally(() => {
        setLoadingMessages(false);
      });
  };

  useEffect(() => {
    if (isEmpty(selectedClients)) return;
    fetchMessages(user?.event_id, 'sc', user?.id, [
      selectedClients[0]?.id,
    ]).then(setMessages);
  }, [selectedClients]);

  //   const sendMessage = (content) => {
  //     const data = {
  //       event_id: eventId,
  //       sender_id: userId,
  //       content,
  //       receiver_ids: [activeUser.id]
  //     };
  //     socket.emit("send_message", data);
  //   };

  const markRead = (messageIds) => {
    socket.emit('read_messages', {
      sender_id: user.id,
      receiver_id: selectedClients[0]?.id,
      message_ids: messageIds,
    });
    setUnreadCounts((prev) => ({ ...prev, [user.id]: 0 }));
  };

  const sendMessage = async (data) => {
    if (selectedClients.length === 0)
      return alert('Select at least one client');

    const payload = {
      sender_id: user.id,
      content: data?.text,
      emcode: data?.dropdown1,
      emaction: data?.dropdown2,
      emlocation: data?.dropdown3,
      attachment_url: !isEmpty(data?.attachments)
        ? JSON.stringify(data?.attachments)
        : '',
      receiver_ids: selectedClients.map((c) => c.id),
    };

    socket.emit('send_message', {
      event_id: user?.event_id,
      sender_id: user.id,
      content: data?.text,
      receiver_ids: selectedClients.map((c) => c.id),
      emcode: data?.dropdown1,
      emaction: data?.dropdown2,
      emlocation: data?.dropdown3,
      attachment_url: !isEmpty(data?.attachments)
        ? JSON.stringify(data?.attachments)
        : '',
    });

    setMessages((prev) =>
      map([...prev, { ...payload, id: last(messages)?.id + 1 }], (msg) => {
        return {
          ...msg,
          created_at : moment().format('YYYY-MM-DDTHH:mm:ss'),
          msg_sender:
            msg.sender_id === parseInt(user.id)
              ? 'C'
              : selectedClients[0]?.gps_unit_name,
        };
      })
    );

    // try {
    //   const res = await axios.post(
    //     `${process.env.REACT_APP_API_URL}/messages/sendmessage/${user?.event_id}`,
    //     payload
    //   );

    //   // setMessages((prev) => [...prev, payload]);

    //   socket.emit('send_message', {
    //     event_id: user?.event_id,
    //     sender_id: user.id,
    //     content: data?.text,
    //     receiver_ids: selectedClients.map((c) => c.id),
    //     emcode: data?.dropdown1,
    //     emaction: data?.dropdown2,
    //     emlocation: data?.dropdown3,
    //     attachment_url: !isEmpty(data?.attachments)
    //       ? JSON.stringify(data?.attachments)
    //       : '',
    //   });

    //   // res.data should be the newly created message object
    //   // Adjust property names according to your API response
    //   // const newMessage = res.data;

    //   // setMessages((prev) => [...prev, newMessage]);
    // } catch (err) {
    //   console.error('Error sending message:', err);
    // }
  };

  const clearCounts = (sender_id, receiver_id) => {
    socket.emit('read_messages', {
      sender_id: sender_id,
      receiver_id: receiver_id,
      // message_ids: Object.keys(counts).filter((id) => counts[id] > 0),
    });
    console.log('Clearing counts:', sender_id, ' and ', receiver_id);
  };

  useEffect(() => {
    if (user?.id && selectedClients[0]?.id) {
      clearCounts(selectedClients[0]?.id, user?.id);
    }
  }, [selectedClients, user?.id, messages]);

  // const markMessagesRead = (clientIds) => {
  //   if (!socket || clientIds.length === 0) return;
  //   socket.emit('mark_read', {
  //     user_id: user.id, // who is reading
  //     client_ids: clientIds, // whose messages are being read
  //   });
  // };

  // useEffect(() => {
  //   if (selectedClients.length > 0) {
  //     // when you open a chat, mark unread messages as read
  //     markMessagesRead(selectedClients.map((c) => c.id));
  //   }
  // }, [selectedClients, messages]);

  console.log('SSC------', messages);

  return (
    // <div className="flex h-screen">
    //   <Sidebar
    //     users={clients}
    //     unreadCounts={unreadCounts}
    //     selectedUsers={selectedClients}
    //     onSelect={setSelectedClients}
    //   />
    //   <div className="flex flex-col flex-1">
    //     <ChatWindow messages={messages} scId={user.id} />
    //     <MessageInput onSend={sendMessage} />
    //   </div>
    // </div>

    <Box sx={{ display: 'flex', height: '100vh', bgcolor: '#e5ddd5' }}>
      {/* Sidebar */}
      <Sidebar
        users={clients}
        unreadCounts={unreadCounts}
        selectedUsers={selectedClients}
        onSelect={setSelectedClients}
      />

      {/* Chat area */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          borderLeft: '1px solid #ddd',
        }}
      >
        {/* Chat window (header + messages) */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            overflow: 'hidden',
          }}
        >
          {console.log('selected', selectedClients)}
          <ChatWindow
            loadingMessages={loadingMessages}
            messages={messages}
            scId={user.id}
            selectedClients={selectedClients}
            selectedUser={
              selectedClients?.length === 1
                ? selectedClients[0]?.username
                : 'BROADCAST ALL'
            }
          />
        </Box>

        {/* Message input */}
        <Box>
          <MessageInput
            onSend={sendMessage}
            disabled={isEmpty(selectedClients)}
            users={clients}
            selectedUsers={selectedClients}
            onSelect={setSelectedClients}
          />
        </Box>
      </Box>
    </Box>
  );
}
